import { SubscriptionStatus } from '@showbie-socrative/socrative-utils';
import { useAtomValue } from 'jotai/index';

import { selectedTeamIdAtom } from '~teacher/components/Account/atoms';
import { useTeams } from '~teacher/hook/team';

function useHasTeamActiveSubscriptionQuery(teamId: string) {
  return useTeams({
    select: (teams) => {
      const team = teams.find((team) => team.id === teamId);
      return [SubscriptionStatus.Active, SubscriptionStatus.Trialing].includes(
        team?.subscription?.status
      );
    },
  });
}

export function useSelectedTeamHasActiveSubscriptionQuery() {
  const selectedTeamId = useAtomValue(selectedTeamIdAtom);
  return useHasTeamActiveSubscriptionQuery(selectedTeamId);
}
